import React, { useState } from 'react';
import { Box, Typography, Button, Container, Grid, useTheme, useMediaQuery, InputAdornment, TextField, IconButton } from '@mui/material';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import PartnersTable from '../components/PartnersTable';
import PartnerFormDrawer from '../components/PartnerFormDrawer';
interface PartnersProps {
  onLogout: () => void;
}
const Partners: React.FC<PartnersProps> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [partnerDrawerOpen, setPartnerDrawerOpen] = useState(false);
  const [editPartner, setEditPartner] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleAddPartner = () => {
    setEditPartner(null);
    setPartnerDrawerOpen(true);
  };
  const handleEditPartner = (partner: any) => {
    setEditPartner(partner);
    setPartnerDrawerOpen(true);
  };
  const handleClosePartnerDrawer = () => {
    setPartnerDrawerOpen(false);
    setEditPartner(null);
  };
  const handleSavePartner = (partnerData: any) => {
    // In a real app, this would save the partner data to the backend
    console.log('Save partner', partnerData);
    setPartnerDrawerOpen(false);
    // Show success toast (would be implemented with a toast library)
  };
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };
  const clearSearch = () => {
    setSearchQuery('');
  };
  const handleManageUsers = (partnerId: string) => {
    // Use React Router navigation instead of window.location.href
    navigate(`/partner-users?partner=${partnerId}`);
  };
  return <Box sx={{
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC'
  }} data-id="element-3905" data-mp="1sg3y54ic8v9q">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} data-id="element-3906" data-mp="3mrlmagunvzaz" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="partners" data-id="element-3907" data-mp="3rnsobyjxsqnn" />
      <Box component="main" sx={{
      flexGrow: 1,
      p: 3,
      width: {
        sm: `calc(100% - ${240}px)`
      },
      ml: 0,
      mt: 8
    }} data-id="element-3908" data-mp="3cxd3wlzchmqj">
        <Container maxWidth="xl" data-id="element-3909" data-mp="38xujrsfclfor">
          {/* Header */}
          <Grid container spacing={2} alignItems="center" sx={{
          mb: 3
        }} data-id="element-3910" data-mp="38zffvmhb96oq">
            <Grid item xs={12} md={6} data-id="element-3911" data-mp="2yz51vzngbv8i">
              <Box sx={{
              display: 'flex',
              alignItems: 'center'
            }} data-id="element-3912" data-mp="2z06movu9rw3f">
                <Icon icon="lucide:building" width={24} height={24} color="#0EA5E9" data-id="element-3913" data-mp="x81sfdpasmpj" />
                <Typography variant="h5" component="h1" sx={{
                ml: 1.5,
                fontWeight: 600
              }} data-id="element-3914" data-mp="2hnzqik9qnm9y">
                  Partners
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} data-id="element-3915" data-mp="30gu00yolem6s">
              <Box sx={{
              display: 'flex',
              gap: 2,
              flexWrap: 'wrap',
              justifyContent: {
                xs: 'flex-start',
                md: 'flex-end'
              }
            }} data-id="element-3916" data-mp="30fitws7od2ci">
                <Button variant="contained" startIcon={<Icon icon="lucide:plus" width={18} height={18} data-id="element-3918" data-mp="1g073zam1mpgj" />} onClick={handleAddPartner} data-id="element-3917" data-mp="35h86icajpo2p">
                  Add Partner
                </Button>
              </Box>
            </Grid>
          </Grid>
          {/* Partners Table */}
          <PartnersTable onEditPartner={handleEditPartner} onManageUsers={handleManageUsers} searchQuery={searchQuery} data-id="element-3919" data-mp="1hi5q5roo5dhv" />
          {/* Partner Form Drawer */}
          <PartnerFormDrawer open={partnerDrawerOpen} partner={editPartner} onClose={handleClosePartnerDrawer} onSave={handleSavePartner} data-id="element-3920" data-mp="1rg20widp26fg" />
        </Container>
      </Box>
    </Box>;
};
export default Partners;